import { render, staticRenderFns } from "./UiMediaObjects.vue?vue&type=template&id=337c4d98&"
import script from "./UiMediaObjects.vue?vue&type=script&lang=js&"
export * from "./UiMediaObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports